<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Aftrekbare scholingsuitgaven
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Met ingang van 2022 zijn studiekosten en andere scholingsuitgaven niet meer aftrekbaar. Een uitzondering
                geldt voor de situatie dat je prestatiebeurs niet is omgezet in een gift.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Prestatiebeurs definitief niet omgezet in een gift
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Je prestatiebeurs wordt een gift als je binnen 10 jaar je diploma haalt nadat je voor het eerst
                studiefinanciering ontvangt. Als de termijn van 10 jaar is verstreken, dan wordt je prestatiebeursschuld
                niet meer omgezet in een gift. De hoogte van de schuld wordt dan door DUO aangeleverd aan de
                Belastingdienst. Dit zie je terug in je vooraf ingevulde aangifte na het verstrijken van de
                diplomatermijn.
                <div class="space10"></div>

                <b>Je prestatiebeurs definitief omgezet in een gift</b><br/>
                Heeft de Dienst Uitvoering Onderwijs (DUO) je lening definitief omgezet in een gift? Dan mag je
                <u>geen</u>
                studiekosten en andere scholingsuitgaven over dat jaar meer aftrekken.
                <div class="space10"></div>

                <b> Je prestatiebeurs definitief niet omgezet in een gift</b><br/>
                Heeft de Dienst Uitvoering Onderwijs (DUO) je lening definitief niet omgezet in een gift, omdat uw
                diplomatermijn is verstreken? Dan hebt je achteraf gezien te weinig studiekosten mogen aftrekken, omdat
                je prestatiebeurs niet als studiekosten werd meegerekend. Je mag in {{ this.year }} alsnog het bedrag
                aftrekken dat
                je eerder niet mocht aftrekken voor studiejaren tot 2014/2015. Vanaf het studiejaar 2015/2016 hebt je
                geen
                recht meer op aftrek van studiekosten voor een studie waarvoor je studiefinanciering hebt gehad.
                <div class="space10"></div>

                Voor de aftrek geldt in principe een vast bedrag. Dit is voor
                € {{ this.bedragMbo | number:'1.0-0' }} € per studiejaar voor een
                mbo-opleiding en € {{ this.bedragHbo | number:'1.0-0' }} per studiejaar voor een hbo- of
                wo-opleiding. Hebt je een deel van het jaar de
                opleiding gevolgd? Dan is het vaste bedrag voor scholingsuitgaven voor een mbo-opleiding
                € {{ this.bedragMboMaand  | number:'1.2-2'}} per
                maand en voor een hbo- of wo-opleiding € {{ this.bedragHboMaand | number:'1.2-2'}} per maand.
                <div class="space10"></div>

                Let op! Was het bedrag van je prestatiebeurs lager? Dan mag je niet alsnog het vaste bedrag van
                € {{ this.bedragMbo | number:'1.0-0' }} of €
                {{ this.bedragHbo | number:'1.0-0' }} aftrekken. Je mag wel het lagere bedrag van de prestatiebeurs
                aftrekken. Zie het voorbeeld hierna.
                <div class="space10"></div>
                Er geldt een drempel van € 250.

            </div>
        </div>
    </div>

</div>


